module.exports = __webpack_public_path__ + "img/logo_questionario.7af8338a.png";